import { billedExtraHours, billedSessionHours, ROUNDING_LABEL, type MentorshipHoursRounding } from '@/hooks/useCustomMentorships';

const fmtH = (n: number) => `${Math.round(n * 100) / 100} h`;

interface Props {
  /** Duración de una sesión, en minutos. */
  minutes?: string | number;
  /** Horas de trabajo fuera de sesión. */
  hours?: string | number;
  /** Regla de redondeo de la mentoría. */
  rounding?: MentorshipHoursRounding;
  className?: string;
}

/**
 * Aviso de cuánto descuenta de la bolsa un registro cuando el redondeo de la
 * mentoría cambia las horas reales.
 */
export function BilledHoursNote({ minutes, hours, rounding = 'quarter_nearest', className = '' }: Props) {
  const isSession = minutes !== undefined;
  const real = isSession ? Number(minutes || 0) / 60 : Number(hours || 0);
  const billed = isSession ? billedSessionHours(Number(minutes || 0), rounding) : billedExtraHours(Number(hours || 0), rounding);
  if (billed === real) return null;
  return (
    <p className={`text-xs text-muted-foreground ${className}`}>
      Se descuentan {fmtH(billed)} de la bolsa: se cobra redondeando al {ROUNDING_LABEL[rounding]}.
    </p>
  );
}
